module.exports = __webpack_public_path__ + "static/media/about_me.bfcca543.jpg";